import { useSelector } from 'react-redux';
import { useAsync } from 'react-use';
import { ComponentContainer } from '@styles/layout';
import { ContentfulApi } from '@model/contentful/service';
import { GenericComponent } from '@model/content';
import { getCMSDestination } from '@state/cms';
import { Experiences } from '@components/product/experiences/Experiences';
import { mapExperiences } from '@util/cms';

export const ExperiencesContainer = ({ path, tripType, data }: GenericComponent) => {
  const destination = useSelector(getCMSDestination(path));

  const { value: experiences } = useAsync(async () => {
    return data ? data : await new ContentfulApi().getExperiencesByDestinationPath(path);
  }, [path]);

  if (!experiences?.items || !tripType || !destination) {
    return null;
  }

  return (
    <ComponentContainer>
      <Experiences destination={destination} experiences={mapExperiences(experiences)} tripType={tripType} />
    </ComponentContainer>
  );
};
